export default {
  postIDLocale: 'I18N_GETTERS_POST_ID_LOCALE',
  translatePostID: 'I18N_GETTERS_TRANSLATE_POST_ID',
  allTranslationsPostIDs: 'I18N_GETTERS_ALL_TRANSLATIONS_POST_IDS'
}
